import { IncomingMessage, ServerResponse } from 'http';

const handleCanonicalPathRedirect = (
    req: IncomingMessage,
    res: ServerResponse,
    canonicalPath: string
) => {
    const path = req.url || '';

    if (!path.startsWith(canonicalPath)) {
        res.writeHead(301, {
            Location: `${canonicalPath}`
        });
        res.end();
    }
};

export default handleCanonicalPathRedirect;
